import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { aplicarTemaSalvo } from './comum';
import './estilo.css';

// Antes do primeiro render: sem isto a página pisca branca por um quadro antes
// de o tema escuro entrar, o que é feio e cansa quem abre a ferramenta no escuro.
aplicarTemaSalvo();

const raiz = document.getElementById('raiz');
if (raiz === null) throw new Error('elemento #raiz não encontrado');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
